import React, { useEffect, useState } from "react";
import { f7, Page, Icon, Badge, Row, Col } from "framework7-react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { API_BASE_URL, API_AUTH } from "./../globals";

const TabHome = () => {
  const [data, setData] = useState([]);
  const [reqBid, setReqBid] = useState([]);
  const [reqOrder, setReqOrder] = useState([]);

  useEffect(() => {
    axios
      .get(API_BASE_URL + "bidcount", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "eventbyrest/id/" + localStorage.getItem("id"), {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          order_status: 1,
          limit: 2,
        },
      })
      .then((response) => {
        setReqBid(response.data.data);
      })

      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "restacceptorder", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
          is_direct_order: true,
        },
      })
      .then((response) => {
        setReqOrder(response.data);
        console.log(response.data.data);
      })
      .catch((error) => console.log(error));
  }, []);

  const opennavigateBid = () => {
    f7.tab.show("#tab-3");
    f7.tab.show("#bid-1");
  };

  const opennavigateConfirm = () => {
    f7.tab.show("#tab-3");
    f7.tab.show("#bid-3");
  };
  const opendirectorders = () => {
    f7.views.main.router.navigate("/directorders/");
  };
  const chartdata = [
    {
      name: "Apr",
      uv: 1500,
      pv: 3800,
      amt: 2400,
    },
    {
      name: "Jun",
      uv: 4100,
      pv: 2500,
      amt: 2400,
    },
    {
      name: "Jul",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Aug",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Sept",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Oct",
      uv: 2780,
      pv: 3908,
      amt: 1000,
    },
  ];

  const divStyle = {
    background: "linear-gradient(to bottom, #F5F7F8, #FFFFFF)",
    // backgroundImage: 'url("https://img.freepik.com/free-vector/autumn-patterned-background_53876-93904.jpg?w=1380&t=st=1698687265~exp=1698687865~hmac=320c691353624694fd90f9b8e5e6e0c7cb5985f77890bfe8575839b75592e23e")',
    // backgroundSize: 'cover',
    // backgroundSize: '20% 80%',
    minHeight: "100vh", // Set the minimum height to the full viewport height
  };

  const backgroundColor = "rgba(255, 255, 255, 0)";

  const divTransparent = {
    background: backgroundColor,
  };

  const handleRefresh = (done) => {
    // Simulate an asynchronous data loading process
    setTimeout(() => {
      done(); // Call done() when the data loading is complete to close the refresh indicator
      const currentRoute = f7.views.main.router.currentRoute;
      f7.views.main.router.navigate(currentRoute.url, {
        reloadCurrent: true,
      });
    }, 2000);
  };

  return (
    <Page
      className="bg-white"
      style={divStyle}
      ptr
      ptrDistance={55}
      onPtrRefresh={handleRefresh}
    >
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <div className="text-center">
            <header className="section-t-space bg-white">
              <div className="custom-container">
                <div className="header-panel pt-3">
                  <h2>Dashboard</h2>
                </div>
              </div>
            </header>
            <section className="mt-3 mb-0 section-t-space profile-form">
              <div className="custom-container p-0" style={divTransparent}>
                {/* <div className="title">
                  <h2 className="mt-0">Welcome to EatBids!</h2>          
                </div> */}
                <div className="container p-0">
                  <div className="row p-0">
                    <div className="col-sm ">
                      <div className="row P-0">
                        <div className="col">
                          <div class="stat-box mb-3 bg-white border text-center">
                            <div class="title">Paid Summary</div>
                            <div class="value text-success">
                              $ {data.paid_amount}
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div class="stat-box mb-3 bg-white border text-center">
                            <div class="title">Yet to pay</div>
                            <div class="value text-warning">
                              $ {data.unpaid_amount}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm ">
                      <div className="row p-0">
                        <div className="col">
                          <div
                            class="stat-box mb-3 bg-white border text-center"
                            onClick={opennavigateBid}
                          >
                            <div class="title">Open Bid</div>
                            <div class="value text-success">
                              {reqBid.length}
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div
                            class="stat-box mb-3 bg-white border text-center"
                            onClick={opennavigateConfirm}
                          >
                            <div class="title">Confirmed</div>
                            <div class="value text-danger">
                              {data.confirm_bid}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm ">
                      <div className="row P-0">
                        <div className="col">
                          <div
                            class="stat-box mb-3 bg-white border text-center"
                            onClick={opennavigateConfirm}
                          >
                            <div class="title">Delivered</div>
                            <div class="value text-success">
                              {data.delivery_bid}
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div class="stat-box mb-3 bg-white border text-center">
                            <div class="title">Cancelled</div>
                            <div class="value text-danger">
                              {data.cancel_bid}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <section className="section-t-space">
              <div className="custom-container p-0 mt-0">
                <div className="title bg-teal1 border rounded p-2" style={{background: '#F6F1E9'}}>
                  <h4 className="mt-0">Order Revenue</h4>                  
                </div>
                  <div class="stat-box p-2 bg-white border">
                  <ResponsiveContainer width="100%" height={200}>
                    {chartdata.length === 0 ? (
                      <div>No data available.</div>
                    ) : (
                      <BarChart
                        data={chartdata}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 0,
                          bottom: 0
                        }}
                        className="text-2"
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="pv" fill="#8884d8" />
                        <Bar dataKey="uv" fill="#82ca9d" />
                      </BarChart>
                    )}
                  </ResponsiveContainer>
                </div>
              </div>
            </section> */}

            {/* <section className="section-t-space">
              <div className="custom-container p-0 mt-0">
                <div className="title bg-teal1 border rounded p-2" style={{background: '#F6F1E9'}}>
                  <h4 className="mt-0">Order Revenue</h4>
                </div>
                  <div class="stat-box p-2 bg-white border">
                  <ResponsiveContainer width="100%" height={200}>
                    {chartdata.length === 0 ? (
                      <div>No data available.</div>
                    ) : (
                      <BarChart
                        data={chartdata}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 0,
                          bottom: 0
                        }}
                        className="text-2"
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="pv" fill="#8884d8" />
                        <Bar dataKey="uv" fill="#82ca9d" />
                      </BarChart>
                    )}
                  </ResponsiveContainer>
                </div>
              </div>
            </section> */}

            <section className="section-t-space">
              <div className="custom-container p-0 mt-0" style={divTransparent}>
                <div
                  className="title bg-teal1 border rounded p-2"
                  style={{ background: "#F6F1E9" }}
                >
                  <h4 className="mt-0" onClick={opennavigateBid}>
                    Review Bid Requests -{" "}
                    <Badge color="teal">{reqBid.length}</Badge>
                  </h4>
                  <a href="#" onClick={opennavigateBid}>
                    <Icon
                      ios="material:keyboard_arrow_right"
                      aurora="material:keyboard_arrow_right"
                      md="material:keyboard_arrow_right"
                      className="text-black"
                    />
                  </a>
                </div>
                <div className="container p-0">
                  <div className="row gy-3">
                    {reqBid.slice(0, 2).map((item, index) => (
                      <div className="bid-web-view-div">
                        <a href={`/eventdetail/${item.id}/1`}>
                          <div className="vertical-product-box order-box bg-white">
                            <div className="vertical-box-img">
                              <img
                                className="img-fluid img"
                                src={require("./../images/events.jpg")}
                                alt="vp1"
                              />
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  {/* <h5 className="dark-text">Ben &amp; Floren</h5> */}
                                  <h5 className="dark-text">
                                    {item.event_name}
                                  </h5>
                                  <h5 className="text-success"></h5>
                                </div>
                                {item.delivery_type == "Delivery" ? (
                                <h6 className="food-items mb-2">
                                  <Icon
                                    ios="material:location_on"
                                    aurora="material:location_on"
                                    md="material:location_on"
                                    className="text-success text-3"
                                  />{" "}
                                  {item.add_lin_1}, {item.city} {item.zip_code}
                                </h6>
                                  ) : (
                                    <h6 className="food-items mb-2"></h6>
                                  )}
                              </div>
                              <div className="reorder">
                                <h6 className="rating-star">
                                  <ul className="timing">
                                    <li>
                                      <Icon
                                        ios="material:groups"
                                        aurora="material:groups"
                                        md="material:groups"
                                        className="text-muted text-4"
                                      />{" "}
                                      {item.event_kids_size +
                                        item.event_adult_size}
                                    </li>
                                    <li>
                                      <Icon
                                        ios="material:event"
                                        aurora="material:event"
                                        md="material:event"
                                        className="text-muted text-4"
                                      />{" "}
                                      {item.event_date}
                                    </li>
                                    <li className="text-success">
                                      {" "}
                                      {item.order_status_text}
                                    </li>
                                  </ul>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
            <section className="section-t-space mb-3">
              <div className="custom-container p-0">
                <div
                  className="title bg-success1 border rounded p-2"
                  style={{ background: "#F6F1E9" }}
                >
                  <h4
                    className="mt-0 text-black"
                    // onClick={opennavigateConfirm}
                    onClick={opendirectorders}
                  >
                    Direct Orders -{" "}
                    <Badge color="teal">{reqOrder.length}</Badge>
                  </h4>
                  <a
                    href="/directorders/"
                    // onClick={opennavigateConfirm}
                  >
                    <Icon
                      ios="material:keyboard_arrow_right"
                      aurora="material:keyboard_arrow_right"
                      md="material:keyboard_arrow_right"
                      className="text-black"
                    />
                  </a>
                </div>
                <div className="container p-0 ">
                  <div className="row gy-3">
                    {reqOrder.slice(0, 2).map((item, index) => (
                      <div className="upcoming-order-div  ">
                        <a href={`/orderview/${item.order_id}/`}>
                          <div className="vertical-product-box order-box bg-white border">
                            <div className="vertical-box-img">
                              <img
                                className="img-fluid img"
                                src={require("./../images/restaurant.png")}
                                alt="vp1"
                              />
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  <h5 className="dark-text">
                                    {item.event_name}
                                  </h5>
                                  {/* <h5 className="text-success">${item.total_amount}</h5> */}
                                </div>
                                {item.delivery_type == "1" ? (
                                  <h6 className="food-items mb-2">
                                    <Icon
                                      ios="material:location_on"
                                      aurora="material:location_on"
                                      md="material:location_on"
                                      className="text-success text-3"
                                    />
                                    {item.add_lin_1
                                      ? `${item.add_lin_1}, ${item.city}`
                                      : item.city}
                                    , {item.zip_code}
                                  </h6>
                                ) : (
                                  <h6 className="food-items mb-2"></h6>
                                )}
                              </div>
                              <div className="reorder">
                                <h6 className="rating-star">
                                  <ul className="timing">
                                    <li>
                                      <Icon
                                        ios="material:groups"
                                        aurora="material:groups"
                                        md="material:groups"
                                        className="text-muted text-4"
                                      />{" "}
                                      {item.event_kids_size +
                                        item.event_adult_size}
                                    </li>
                                    <li>
                                      <Icon
                                        ios="material:event"
                                        aurora="material:event"
                                        md="material:event"
                                        className="text-muted text-4"
                                      />{" "}
                                      {item.date}
                                    </li>
                                    {/* <li className="text-success"> Requested</li> */}
                                  </ul>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default TabHome;
